import React from 'react'
import { Link } from '@inertiajs/react'

import { Chip } from '@material-tailwind/react'
import { toast } from 'react-toastify'

import Editable from '@/Shared/Editable'

import { getItemStatus } from '@/utils'

export default function({
                            id,
                            title,
                            arrivedDate,
                            item,
                            total,
                            consumed,
                            remaining,
                            percentage,
                            setValues
                        }) {

    function shouldNavigate(e) {
        if (!arrivedDate) {
            toast.error(`Missing ${title} Arrived Date!`)
            e.preventDefault()
        }
    }

    return (
        <tr className="focus-within:bg-gray-100 hover:bg-gray-100">
            <td className="border-t">
                <Link
                    tabIndex="-1"
                    onClick={shouldNavigate}
                    href={route('consumed.create', {
                        item,
                        consumable: id
                    })}
                    className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                >
                    {title}
                </Link>
            </td>

            <td className="border-t">
                <Link
                    tabIndex="-1"
                    onClick={shouldNavigate}
                    href={route('consumed.create', {
                        item,
                        consumable: id
                    })}
                    className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                >
                    {total}
                </Link>
            </td>

            <Editable
                id={id}
                value={arrivedDate}
                name={`${item}_arrived_date`}
                link={route('consumed.create', {
                    item,
                    consumable: id
                })}
                setData={setValues}
            />

            <td className="border-t">
                <Link
                    href={route('consumed.create', {
                        item,
                        consumable: id
                    })}
                    onClick={shouldNavigate}
                    className="flex items-center px-6 py-4 focus:text-indigo-700 focus:outline-none"
                >
                    {consumed}
                </Link>
            </td>

            <td className="border-t">
                <Link
                    tabIndex="-1"
                    onClick={shouldNavigate}
                    href={route('consumed.create', {
                        item,
                        consumable: id
                    })}
                    className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                >
                    {remaining}
                </Link>
            </td>

            <td className="border-t">
                <Link
                    tabIndex="-1"
                    onClick={shouldNavigate}
                    href={route('consumed.create', {
                        item,
                        consumable: id
                    })}
                    className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                >
                    <Chip color={getItemStatus(percentage)} value={percentage} />
                </Link>
            </td>
        </tr>
    );
}
